import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      class="design-iconfont"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M4.5,1.5 C3.67265625,1.5 3,2.17265625 3,3 L3,21 C3,21.8273437 3.67265625,22.5 4.5,22.5 L19,22.5 C20.1045695,22.5 21,21.6045695 21,20.5 L21,3.5 C21,2.3954305 20.1045695,1.5 19,1.5 L4.5,1.5 L4.5,1.5 Z M6,3 L6,17.296875 L5.6015625,17.296875 C5.2078125,17.296875 4.83515625,17.3835937 4.5,17.540625 L4.5,3 L6,3 Z M5.6015625,21 C4.99453125,21 4.5,20.5054687 4.5,19.8984375 C4.5,19.2914063 4.99453125,18.796875 5.6015625,18.796875 L19.5,18.796875 L19.5,21 L5.6015625,21 Z M7.5,17.296875 L7.5,3 L15,3 L15,8.25 L16.5,6.76171875 L18,8.25 L18,3 L19.5,3 L19.5,17.296875 L7.5,17.296875 Z"
        fill-rule="nonzero"
      />
    </svg>
  )
}

const ManualIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default ManualIcon
